import script from "./RemoveModal.vue?vue&type=script&setup=true&lang=js"
export * from "./RemoveModal.vue?vue&type=script&setup=true&lang=js"

import "./RemoveModal.vue?vue&type=style&index=0&id=6f69cc7e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f69cc7e"]])

export default __exports__